<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="bannerTable">
        <el-table
          ref="multipleTable"
          :data="productAreas"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column prop="id" label="序号" width="60"> </el-table-column>
          <el-table-column prop="title" label="标题" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="编辑商品专区"
        :visible.sync="editDialogVisible"
        :append-to-body="true"
        width="50%"
        :modal="false"
      >
        <el-form label-position="left" label-width="80px" :model="controlData">
          <el-form-item label="标题:">
            <el-input v-model="controlData.title"></el-input>
          </el-form-item>
          <!--          <el-form-item label="标题:">-->
          <!--            {{controlData.title}}-->
          <!--          </el-form-item>-->

          <el-form-item label="关联商品">
            <el-select
              multiple
              v-model="controlData.spuId"
              style="width: 460px;"
            >
              <el-option
                v-for="item in productDatas"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="背景图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSingleProductFile"
              :on-remove="handleImgRemove"
              :limit="100"
              :file-list="fileList2"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_setAreaProduct()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getProductArea,
  setAreaProduct,
  getAllProduct1,
  uploadFile2
} from "api/request";
import { getDepartment } from "api/post";
import { ERR_OK } from "api/config";
import { formatDate, loadingInstance, Success, Error } from "common/js/util";
export default {
  components: { MSidebar, MHeader },
  data() {
    return {
      fileList2: [], // 初始化 fileList2 为空数组
      singleProduct: {
        images: [] // 初始化 images 数组
      },
      supplierId: null, //供应商id
      categoryId: null, //分类id
      keywords: null,
      imageUrl: null,
      productDatas: [],
      fileList: [],
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      detailDialogVisible: false,
      pushDialogVisible: false,
      editDialogVisible: false,
      addDialogVisible: false,
      editTitleDialogVisible: false,
      freezeDialogVisible: false,
      deleteDialogVisible: false,
      controlData: {},
      userDetail: [],
      productAreas: [],
      cfAdminVos: []
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this._getList();
      this._getProduct();
    }
  },
  methods: {
    // 删除背景图
    // 在删除图片时更新 images 数组
    // handleImgRemove(file, fileList) {
    //   this.singleProduct.images = fileList.map(f => f.url || f.name);
    // },
    handleImgRemove(file, fileList) {
      // 这里使用 file.url 检查被删除的文件是不是原始文件
      if (file.url) {
        const index = this.singleProduct.images.indexOf(file.url);
        if (index !== -1) {
          this.singleProduct.images.splice(index, 1); // 从 images 数组中移除
        }
      } else {
        // 如果 file.url 不存在，说明是新上传的文件
        this.singleProduct.images = this.singleProduct.images.filter(
          img => img !== file.name
        );
      }
    },
    // 上传背景图
    uploadSingleProductFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 103);
      uploadFile2(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.singleProduct.images.push(res.data);
        } else {
          Error(this, res);
        }
      });
    },
    handleClose(item) {
      this.deleteDialogVisible = true;
      this.controlData = item;
    },
    handleChange() {
      console.log(this.status);
    },
    pageChange(val) {
      console.log(val);
      this.pageNum = val;
      this.productAreas = [];
      this._getList();
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.productAreas[index];
    },
    // handleEdit(index, row) {
    //   this.editDialogVisible = true;
    //   this.controlData = JSON.parse(JSON.stringify(this.productAreas[index]));
    //   this.fileList2 = row.imageUrl
    //     ? [{ name: "已上传的图片", url: row.imageUrl }]
    //     : [];
    // },
    handleEdit(index, row) {
      this.editDialogVisible = true;
      this.controlData = JSON.parse(JSON.stringify(this.productAreas[index]));
      this.fileList2 = row.imageUrl
        ? [{ name: "已上传的图片", url: row.imageUrl }]
        : [];
      this.singleProduct.images = row.imageUrl ? [row.imageUrl] : []; // 重置 images 数组
    },
    handleShowDetail(row) {
      this.detailDialogVisible = true;
      this.userDetail = [row];
    },
    handleShowPush(row) {
      this.cfAdminVos = row.cfAdminVos;
      this.pushDialogVisible = true;
    },
    _getList() {
      let param = {};
      loadingInstance(Loading);
      getProductArea(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.productAreas = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getProduct() {
      let param = {};
      loadingInstance(Loading);
      getAllProduct1(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.productDatas = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // _setAreaProduct() {
    //   let param = {
    //     title: this.controlData.title,
    //     bannerId: this.controlData.id,
    //     spuIds: this.controlData.spuId,
    //     // imageUrl: this.singleProduct.images[0] // 假设您只需要上传一个图片的 URL
    //     imageUrl:
    //       this.singleProduct.images.length > 0
    //         ? this.singleProduct.images[0]
    //         : null
    //   };
    //   loadingInstance(Loading);
    //   setAreaProduct(param).then(res => {
    //     loadingInstance(Loading).close();
    //     if (res.status === ERR_OK) {
    //       this.editDialogVisible = false;
    //       this.controlData = {};
    //       this._getList();
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    _setAreaProduct() {
      let imageUrlToSend;
      if (this.singleProduct.images.length > 0) {
        // 如果有新上传的图片
        imageUrlToSend = this.singleProduct.images[0].includes("/")
          ? this.singleProduct.images[0].split("/").pop()
          : this.singleProduct.images[0];
      } else {
        // 如果没有新上传的图片，提取原始图片URL中的相对路径
        imageUrlToSend = this.controlData.imageUrl.split("/").pop();
      }

      let param = {
        title: this.controlData.title,
        bannerId: this.controlData.id,
        spuIds: this.controlData.spuId,
        imageUrl: `bannerImage/${imageUrlToSend}`
      };

      loadingInstance(Loading);
      setAreaProduct(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.editDialogVisible = false;
          this.controlData = {};
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },

    // 修改类型
    onChangeType() {
      this.controlData.groupNum = "1";
    },
    // 修改关联类型
    onChangeInfoType() {
      this.controlData.unionIds = [];
      this.controlData.unionId = null;
      console.log("hxl" + this.controlData.unionIds);
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped>
.bannerOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}
.bannerTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}
.bannerOperate .el-input {
  width: 220px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.bannerOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/system/productArea.vue